import { apiService } from './apiService';

export interface LLMConfigurationDto {
  tenantId?: string;
  provider: string;
  apiKey?: string;
  endpointUrl?: string;
  costPreference?: string;
  isDefault?: boolean;
  lastUsedAt?: string;
  modelName?: string;
  region?: string;
  apiVersion?: string;
  temperature?: number;
  topP?: number;
  maxTokens?: number;
  rateLimitPerMinute?: number;
  isActive?: boolean;
  additionalConfigJson?: string;
}

export interface LLMConfiguration {
  id: string;
  tenantId: string;
  provider: string;
  apiKey?: string;
  endpointUrl?: string;
  costPreference?: string;
  isDefault?: boolean;
  lastUsedAt?: string;
  modelName?: string;
  region?: string;
  apiVersion?: string;
  temperature?: number;
  topP?: number;
  maxTokens?: number;
  rateLimitPerMinute?: number;
  isActive?: boolean;
  additionalConfigJson?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const llmConfigurationService = {
  getList: () =>
    apiService.get('/api/LLMConfiguration/list', {}, 'backend') as Promise<LLMConfiguration[]>,

  getById: (id: string) =>
    apiService.get(`/api/LLMConfiguration/details/${id}`, {}, 'backend') as Promise<LLMConfiguration>,

  create: (dto: LLMConfigurationDto) =>
    apiService.post('/api/LLMConfiguration', dto, 'backend'),

  update: (id: string, dto: LLMConfigurationDto) =>
    apiService.put(`/api/LLMConfiguration/${id}`, dto, 'backend'),

  delete: (id: string) =>
    apiService.delete(`/api/LLMConfiguration/${id}`, 'backend'),

  setActive: (id: string, isActive: boolean) =>
    apiService.patch(`/api/LLMConfiguration/${id}/active`, { isActive }, 'backend'),
};
